<template>
  <v-flex>
    <div class="mb-6">
      <v-btn to="/active/create" color="orange">新增</v-btn>
    </div>

    <v-data-table :headers="thead" :items="actives" disable-pagination hide-default-footer>
      <template v-slot:item.no="{ item }">
        <span class="blue--text">{{ item.no }}</span>
      </template>

      <template v-slot:item.available="{ item }">
        <template v-if="item.available">
          <v-icon color="green" class="mr-3">mdi-checkbox-blank-circle</v-icon>啟用
        </template>
        <template v-else>
          <v-icon color="blue-grey lighten-3" class="mr-3">mdi-checkbox-blank-circle-outline</v-icon>停用
        </template>
      </template>

      <template v-slot:item.serial_number="{ item }">
        <v-btn :to="`/active/serial-number/${item.active_id}`" outlined color="blue">序號</v-btn>
      </template>

      <template v-slot:item.weekday_type="{ item }">
        <template v-if="(item.weekday_type == 0)">全時段使用</template>
        <template v-else-if="(item.weekday_type == 1)">優惠時段專用</template>
      </template>

      <template v-slot:item.active_id="{ item }">
        <v-btn :to="`/active/${item.active_id}`" outlined color="blue">檢視/修改</v-btn>
      </template>

      <template v-slot:item.delete="{ item }">

        <v-btn @click="deleteRow(item.active_id)" color="red">刪除</v-btn>
        <!-- <v-btn @click="deleteRow(item.active_id)" outlined color="red" >刪除</v-btn> -->
      </template>


    </v-data-table>
    <Confirm @confirm="deleteConfirm" :dialog="dialog" title="是否確認刪除？" text />
  </v-flex>
</template>



<script>
import { mapState, mapActions } from "vuex";

import activesApi from "@/api/actives";
import Confirm from "@/components/Confirm";

export default {
  components: {
    Confirm
  },

  mixins: [],

  props: [],
  data() {
    return {
      actives: [],

      dialog: false,
      valid: false,
      delete_id: null,

      thead: [
        {
          text: "",
          value: "no",
          align: "center"
        },
        {
          text: "活動名稱",
          value: "active_name"
        },
        {
          text: "活動代號",
          value: "active_code"
        },
        {
          text: "序號金額",
          value: "points"
        },
        {
          text: "平日/假日使用",
          value: "weekday_type",
          align: "right"
        },
        {
          text: "隱藏秒數",
          value: "hide_seconds",
          align: "right"
        },
        {
          text: "開始時間",
          value: "start_time"
        },
        {
          text: "結束時間",
          value: "end_time"
        },
        {
          text: "啟用狀態",
          value: "available"
        },
        {
          text: "",
          value: "serial_number"
        },
        {
          text: "",
          value: "active_id"
        },
        {
          text: "刪除",
          value: "delete"
        }
      ]
    };
  },

  computed: {},
  watch: {},
  methods: {
    deleteRow(val) {
      this.dialog = true
      this.delete_id = val;
    },
    deleteConfirm(result) {
      this.dialog = false;

      if (result) {
        //this.delete(this.delete_id);

        activesApi
          .deleteByID(this.delete_id)
          .then(res => {
            window.location.reload();
          })
          .catch(err => {});

      }
    },


  },

  mounted() {
    activesApi
      .getAll()
      .then(res => {
        this.actives = res.data;

        this.actives.forEach((item, idx) => {
          item.no = idx + 1;
        });
      })
      .catch(err => {});
  }
};
</script>

<style lang="scss" scoped>
</style>
